import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './css/HomeSectionsGrid.css';
import UpcomeMassTime from './UpcomeMassTime';
import { ApiUrl } from '../API/ApiUrl';
import axios from 'axios';

const HomeSectionsGrid = ({ projectdata }) => {
    const [announcements, setAnnouncements] = useState([]);
    const [specialMass, setSpecialMass] = useState([]);
    const [weeklySchedule, setWeeklySchedule] = useState(null);
    const [loadingAnnouncements, setLoadingAnnouncements] = useState(true);
    const [loadingSpecialMass, setLoadingSpecialMass] = useState(true);
    const [loadingWeekly, setLoadingWeekly] = useState(true);

    useEffect(() => {
        // Fetch announcements
        axios.get(`${ApiUrl}/get/announcements`)
            .then(response => {
                if (response.data.success) {
                    setAnnouncements(response.data.data);
                }
                setLoadingAnnouncements(false);
            })
            .catch(error => {
                console.error('Error fetching announcements:', error);
                setLoadingAnnouncements(false);
            });

        // Fetch special mass timings
        axios.get(`${ApiUrl}/get/special-mass-timings`)
            .then(response => {
                if (response.data.success) {
                    setSpecialMass(response.data.data);
                }
                setLoadingSpecialMass(false);
            })
            .catch(error => {
                console.error('Error fetching special mass timings:', error);
                setLoadingSpecialMass(false);
            });

        // Fetch weekly schedule
        axios.get(`${ApiUrl}/get/weekly-schedule`)
            .then(response => {
                if (response.data.success) {
                    setWeeklySchedule(response.data.data);
                }
                setLoadingWeekly(false);
            })
            .catch(error => {
                console.error('Error fetching weekly schedule:', error);
                setLoadingWeekly(false);
            });
    }, []);

    // Helper to format weekly schedule list
    const renderWeeklySchedule = () => {
        if (loadingWeekly) return <p>Loading schedule...</p>;
        if (!weeklySchedule) return <p>Schedule not available.</p>;

       // const days = ['Sunday', 'Daily', 'Thu & Sat'];
        const scheduleItems = [];

        // Sunday
        if (weeklySchedule.Sunday && weeklySchedule.Sunday.length > 0) {
            scheduleItems.push(
                <p key="Sunday" className="mb-1">
                    <b>Sunday:</b> {weeklySchedule.Sunday.join(', ')}
                </p>
            );
        }

        // Daily (Mon-Wed, Fri)
        const dailyTimes = weeklySchedule.Monday || []; // Assume Monday represents "Daily"
        if (dailyTimes.length > 0) {
            scheduleItems.push(
                <p key="Daily" className="mb-1">
                    <b>Daily:</b> {dailyTimes.join(', ')}
                </p>
            );
        }

        // Thu & Sat
        const thuTimes = weeklySchedule.Thursday || [];
        const satTimes = weeklySchedule.Saturday || [];
        const commonTimes = thuTimes.filter(t => satTimes.includes(t));
        if (commonTimes.length > 0) {
            scheduleItems.push(
                <p key="ThuSat" className="mb-1">
                    <b>Thu & Sat:</b> {commonTimes.join(', ')}
                </p>
            );
        }

        return scheduleItems.length > 0 ? scheduleItems : <p>Regular schedule not set.</p>;
    };

    return (
        <div className="home-sections-grid-container container">
            <div className="home-grid">
                {/* About Church Section */}
                <section className="grid-item about-church" style={{ backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), url('assets/images/bgnew.jpg')" }}>
                    <div className="title"><h2> WELCOME TO OUR LADY OF FATIMA SHRINE KRISHNAGIRI</h2></div>
                    <div className="content">
                        {/* <h2 className="entry-title">KRISHNAGIRI</h2> */}
                        <p>
                            Our Lady of Fatima Shrine stands as a revered Roman Catholic church, nestled in the heart of Krishnagiri town in the Krishnagiri district of Tamil Nadu, India. Affiliated with the Dharmapuri diocese, this church boasted 850 parishioners, making it one of the largest parishes in the diocese.
                        </p>
                        <p>
                            The church's rich history dates back to 1832 when Loyola Ignatius Church was erected for British soldiers and local Catholics. In the 1890s, the church transitioned into the hands of MEP Priests, functioning as a sub-station of Elathagiri parish. Over the years, Krishnagiri church evolved, and in 1930, it became a full-fledged parish under the Salem Diocese for over 70 years. </p>
                        <p>
                            In 1972, the iconic Our Lady of Fatima Shrine Church was built, becoming the new parish church for Krishnagiri. The church's annual feast, celebrated on the Sunday after July 13, has become a renowned event in the town. The church's spiritual significance is heightened by the presence of the Fatima Mary statue, originating from Fátima, Portugal.
                        </p>
                        <p>
                            Since 1997, Our Lady of Fatima Shrine has been serving under the Dharmapuri diocese, continuing its legacy as a beacon of faith, history, and community in Krishnagiri. </p>
                    </div>
                    <div className="read-more-container">
                        <Link to="/history" className="read-more-link">Read More <i className="fa fa-arrow-right"></i></Link>
                    </div>
                </section>

                {/* Announcements Section */}
                <section className="grid-item announcements">
                    <div className="title"><i className="fa fa-bullhorn"></i> Announcements</div>
                    <div className="content">
                        {loadingAnnouncements ? (
                            <p>Loading announcements...</p>
                        ) : announcements && announcements.length > 0 ? (
                            announcements.map((item) => (
                                <div key={item.id} className="news-item">
                                    <span className="news-date">{item.start_date || item.created_date}</span>
                                    <Link to={`/news?newsid=${item.id}`} className="news-title">{item.title}</Link>
                                </div>
                            ))
                        ) : (
                            <p>No new announcements at this time.</p>
                        )}
                    </div>
                    <div className="read-more-container">
                        <Link to="/announcements" className="read-more-link">View All <i className="fa fa-arrow-right"></i></Link>
                    </div>
                </section>

                {/* Church Mass Timing Section */}
                <section className="grid-item mass-timing">
                    <div className="title"><i className="fa fa-clock-o"></i> Church Mass Timing</div>
                    <div className="content">
                        <UpcomeMassTime />
                        <div className="mt-3">
                            {renderWeeklySchedule()}
                        </div>
                    </div>
                    <div className="read-more-container">
                        <Link to="/masstimings" className="read-more-link">Full Schedule <i className="fa fa-arrow-right"></i></Link>
                    </div>
                </section>

                {/* Calendar Section */}
                <section className="grid-item calendar-card">
                    <div className="title"><i className="fa fa-calendar"></i> Calendar</div>
                    <div className="content text-center">
                        <div className="calendar-icon-box">
                            <i className="fa fa-calendar-check-o"></i>
                        </div>
                        <p>Check the daily mass schedule and special liturgical events.</p>
                    </div>
                    <div className="read-more-container">
                        <Link to="/masstimings" className="read-more-link">View Calendar <i className="fa fa-arrow-right"></i></Link>
                    </div>
                </section>

                {/* Donation Bank Details Section */}
                <section className="grid-item donation-card">
                    <div className="title"><i className="fa fa-money"></i> Bank Details</div>
                    <div className="content">
                        <div className="bank-info">
                            <div className="bank-row">
                                <span className="bank-label">Bank Name</span>
                                <span className="bank-value">OUR LADY OF FATIMA RENOVATION FUND</span>
                            </div>
                            <div className="bank-row">
                                <span className="bank-label">Account Number</span>
                                <span className="bank-value">19930100068839</span>
                            </div>
                            <div className="bank-row">
                                <span className="bank-label">IFSC Code</span>
                                <span className="bank-value">FDRL0001993</span>
                            </div>
                            <div className="bank-row">
                                <span className="bank-label">UPI ID</span>
                                <span className="bank-value">fatimachurch@fbl</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Special Mass Timing Section */}
                <section className="grid-item special-mass-card">
                    <div className="title"><i className="fa fa-star"></i> Special Mass Timing</div>
                    <div className="content">
                        {loadingSpecialMass ? (
                            <p>Loading...</p>
                        ) : specialMass && specialMass.length > 0 ? (
                            specialMass.map((event) => (
                                <div key={event.id} className="event-detail mb-3">
                                    <h5 className="mb-1" style={{ color: '#cd2653' }}>{event.title}</h5>
                                    <p className="mb-1"><small className="text-muted">{event.eventdate_formatted}</small></p>
                                    <div className="event-excerpt" dangerouslySetInnerHTML={{ __html: event.content ? event.content.substring(0, 100) : '' }} />
                                </div>
                            ))
                        ) : (
                            <p>No special mass timings at this time.</p>
                        )}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default HomeSectionsGrid;
